import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform{
  transform(rawNum): string {
    const reg = /^\+48/;

    if (!reg.test(rawNum)) {
      rawNum = '+48' + rawNum;
    }

    let newStr = '';

    for (let i = 0; i < rawNum.length; i++) {
      newStr = newStr + rawNum.charAt(i);

      if ((i + 1) % 3 === 0) {
        newStr = newStr + ' ';
      }
    }

    return newStr.trim();
  }
}
